export enum MainViewStates {
  LogoPlacer, LogoEditor
}